import { Component, inject } from '@angular/core';
import { ButtonsModule, DialogModule, DialogService, IconModule, PanelModule, SnackBarService } from '@mastechnicaegroup/carelinelive-ui';
import { ErrorPanelComponent } from '@lib/errors/error-panel/error-panel.component';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { SettingsService } from '@lib/setting/settings.service';
import { HandbackReasons, HandbackReasonSingleResponse, StoreHandbackReasonRequest } from '@lib/api/models/setting';
import { SendableRequest } from '@mastechnicaegroup/carelinelive-cdk/requests';

@Component({
    selector: 'app-prompt-handback-status-change-dialog',
    imports: [
        ButtonsModule,
        DialogModule,
        ErrorPanelComponent,
        IconModule,
        PanelModule
    ],
    templateUrl: './prompt-handback-status-change-dialog.component.html',
    standalone: true,
    styleUrl: './prompt-handback-status-change-dialog.component.scss'
})
export class PromptHandbackStatusChangeDialogComponent {
    protected readonly dialogRef = inject<DialogRef>(DialogRef);
    private readonly _settingService = inject(SettingsService);
    private readonly _snackBar = inject(SnackBarService);
    protected readonly handbackReason = inject<HandbackReasons>(DIALOG_DATA);

    updateHandbackReasonRequest = new SendableRequest<HandbackReasonSingleResponse, StoreHandbackReasonRequest>({
        request: (payload) => this._settingService.updateHandbackReason(this.handbackReason.id, payload!),
        onSuccess: () => {

            this._snackBar.open({
                colour: 'success',
                dismissable: false,
                icon: 'check_circle',
                title: 'Handback Reason status changed successfully',
                actions: [
                    { id: 'undo', label: 'OK' }
                ]
            });

            this.dialogRef.close();
        },
        onError: () => {
            this._snackBar.open({
                colour: 'error',
                dismissable: false,
                icon: 'error_outline',
                title: 'Handback Reason status failed to change',
                actions: [
                    { id: 'undo', label: 'OK' }
                ]
            });
        }
    });

    update() {
        this.updateHandbackReasonRequest.send(this.handbackReason);
    }

    public static show(dialog: DialogService, data: HandbackReasons) {
        return dialog.openDialog<DialogRef, HandbackReasons>(PromptHandbackStatusChangeDialogComponent, {
                data
            }
        );
    }
}
